import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'

import style from '../style'

export const Authbar = props => {
  return (
    <Container>
      <Row
        className={`d-flex justify-content-end justify-content-sm-between align-items-center ${css(
          style.authbar.content
        )}`}
      >
        <Col />
        <Col xs='auto'>
          {props.token.accessToken ? (
            <span
              onClick={props.onLogoutClick}
              className={`d-block ${css(style.authbar.listItemLink)}`}
            >
              <i
                className={`fa fa-angle-right ${css(
                  style.authbar.listItemIcon
                )}`}
                aria-hidden='true'
              />
              Logout
            </span>
          ) : (
            <ul className={`d-flex ${css(style.authbar.list)}`}>
              <li>
                <Link
                  to='/login'
                  className={`d-block ${css(style.authbar.listItemLink)}`}
                >
                  <i
                    className={`fa fa-angle-right ${css(
                      style.authbar.listItemIcon
                    )}`}
                    aria-hidden='true'
                  />
                  Login
                </Link>
              </li>
              <li>
                <Link
                  to='/signup'
                  className={`d-block ${css(style.authbar.listItemLink)}`}
                >
                  <i
                    className={`fa fa-angle-right ${css(
                      style.authbar.listItemIcon
                    )}`}
                    aria-hidden='true'
                  />
                  Signup
                </Link>
              </li>
            </ul>
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default Authbar



// WEBPACK FOOTER //
// ./src/components/partials/Header/partials/authbar.js